import PropTypes from "prop-types";
import { providerFactory } from "../../../../../universal/featuresStore";
import { Provider as StoreProvider } from "react-redux";
import store from "../../../../state/store";
import { UrlProvider } from "../UrlProvider";
import ErrorBoundary from "../ErrorBoundary";
import Main from "../Main";

const FeaturesProvider = providerFactory();

const App = ({ EntryPoint }) => (
  <FeaturesProvider>
    <ErrorBoundary>
      <UrlProvider>
        <StoreProvider store={store}>
          <Main EntryPoint={EntryPoint} />
        </StoreProvider>
      </UrlProvider>
    </ErrorBoundary>
  </FeaturesProvider>
);

App.propTypes = {
  EntryPoint: PropTypes.elementType.isRequired
};

export default App;
